module.exports = __webpack_public_path__ + "static/media/icon-avatar--gray.f2688fee.svg";